<mat-toolbar color="secondary" class="toolbar">

  <button
    routerLink="/"
    matTooltip="Home"
    mat-icon-button
    aria-label="Home icon-button with home icon">
    <mat-icon>home</mat-icon>
  </button>

  <button
    routerLink="/portfolio"
    matTooltip="Portfolio"
    mat-button
    aria-label="Portfolio button">
    Portfolio
  </button>

  <!--<button
  routerLink="/favorites"
  matTooltip="Favorite books and courses"
  mat-icon-button
  aria-label="Favorite icon-button with heart icon">
  <mat-icon>favorite</mat-icon>
</button>-->

<span class="spacer"></span>

  <button
    routerLink="/contact"
    matTooltip="Contact me"
    mat-icon-button
    aria-label="Contact page icon-button with contact_page icon">
    <mat-icon>contact_page</mat-icon>
  </button>

  <button
    routerLink="/login"
    matTooltip="View private projects"
    mat-button
    aria-label="Viewer access for hidden projects">
    Private
  </button>

@if ((isAdmin$ | async) === true) {
  <button
    routerLink="/admin/projects"
    matTooltip="Admin projects"
    mat-icon-button
    aria-label="Admin projects icon-button with dashboard icon">
    <mat-icon>dashboard</mat-icon>
  </button>
}

@if ((isAuthenticated$ | async) === true) {
  <button
    (click)="logout()"
    matTooltip="Logout"
    mat-icon-button
    aria-label="Logout icon-button with logout icon">
    <mat-icon>logout</mat-icon>
  </button>
}

</mat-toolbar>